export const useInAppView = () => {
  const route = useRoute();
  const inAppView = computed(() => route?.query?.in_app_view === 'true');
  return { inAppView };
};
